/**
 * Move an element in an array without mutating the original array.
 *
 * @param array - Original array
 * @param fromIndex - From index to move element from
 * @param toIndex - To index to move element to
 * @returns - Array with updated position of element
 */
export function moveElement<T>(array: T[], fromIndex: number, toIndex: number): T[] {
    if (fromIndex < 0 || fromIndex >= array.length) {
        return array;
    }
    const newArray = array.slice();
    const element = newArray.splice(fromIndex, 1)[0];
    newArray.splice(toIndex, 0, element);
    return newArray;
}
